<div [id]="blogContainerId" class="page-shell">
  <!-- <app-small-header textColor="#fff" [homePage]="true"></app-small-header> -->

  <div class="hero-offset">
    @if (selectedDestination?.videoBanner?.videoBannerUrl?.trim()) {
    <div class="hero-video-wrapper">
      <video #heroVideo autoplay loop playsinline class="hero-video" [muted]="isMuted">
        <source [src]="selectedDestination?.videoBanner?.videoBannerUrl"
          [type]="getVideoMimeType(selectedDestination?.videoBanner?.videoBannerUrl)" />
      </video>

      @if (selectedDestination?.videoBanner?.heading?.trim() || selectedDestination?.videoBanner?.subHeading?.trim()) {
      <div class="hero-video-text">
        @if (selectedDestination?.videoBanner?.heading?.trim()) {
        <h1>{{ selectedDestination?.videoBanner?.heading }}</h1>
        }
        @if (selectedDestination?.videoBanner?.subHeading?.trim()) {
        <p>{{ selectedDestination?.videoBanner?.subHeading }}</p>
        }
      </div>
      }
    </div>
    }@else {
    <app-hero-banner [heading]="
          destination && destination !== 'all'
            ? (selectedDestination?.name ? selectedDestination.name + ' Hotels' : '')
            : 'Our Hotels'
        " [text]="'Good Stays, Across Great Destinations'"
      backgroundImageUrl="assets/images/backgrounds/hotels-listing-bg.jpg">
    </app-hero-banner>
    }
  </div>

  <div>
    <div class="container">
      <div>
        @if (hotelList && hotelList.length > 0) {
        <app-hotel-listing-card [hotel]="hotelList" [destinationId]="destination"
          (destinationTabChange)="onDestinationTabChange($event)">
        </app-hotel-listing-card>
        }
      </div>

      <!-- <app-home-upcoming-properties></app-home-upcoming-properties> -->
    </div>
  </div>
</div>